import { useState, useEffect } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export default function LegalPage() {
  const { t } = useLanguage();
  const { pathname } = useLocation();

  const PAGE_MAP = {
    '/privacy': 'privacy',
    '/commercial-law': 'commercialLaw',
    '/sustainability': 'sustainability',
  };

  const type = PAGE_MAP[pathname] || 'privacy';
  const apiType = pathname === '/commercial-law' ? 'commercial-law' : type;

  const title = t(`contentPages.legal.${type}.title`);
  const subtitle = t(`contentPages.legal.${type}.subtitle`);

  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    axios.get(`${API}/legal/${apiType}`).then(r => setContent(r.data.content || '')).catch(() => setContent('')).finally(() => setLoading(false));
  }, [apiType]);

  return (
    <div className="min-h-screen bg-gray-50" data-testid={`legal-${apiType}`}>
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8 lg:py-12">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">{title}</h1>
          <p className="text-gray-500">{subtitle}</p>
        </div>
      </div>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {loading ? (
          <div className="text-center text-gray-400 py-20">{t('contentPages.legal.loading')}</div>
        ) : content ? (
          <div className="bg-white rounded-lg shadow-sm p-8 prose prose-gray max-w-none whitespace-pre-wrap text-gray-700 leading-relaxed">
            {content}
          </div>
        ) : (
          <div className="bg-white rounded-lg shadow-sm p-12 text-center text-gray-400">
            {t('contentPages.legal.noContent')}
          </div>
        )}
      </div>
    </div>
  );
}
